import { ChatServiceQrImgTfsoftware } from 'bizComponents/ChatServiceQrImg';
import CompanyInfo from './components/CompanyInfo';
import styled from '@emotion/styled';
import { useTranslate } from '@tolgee/react';

function TFMarket() {
  const { t } = useTranslate();

  return (
    <Container>
      <header>
        <CompanyInfo />
      </header>
      <section>
        <p>{t('not_support_order_service_online')}</p>
        <ChatServiceQrImgTfsoftware />
      </section>
    </Container>
  );
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 16px;
  > header {
    flex: 0 0 auto;
    margin-bottom: 16px;
  }
  > section {
    flex: 1 0 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background: #fff;
    border-radius: 4px;
    > p {
      padding: 6px 100px;
      margin-bottom: 32px;
      background: #f0f7ff;
      border-radius: 100px;
    }
    > div {
      gap: 32px;
    }
    > div > div {
      padding-top: 14px;
      background: #f5f5f5;
      border-radius: 4px;
    }
  }
`;

export default TFMarket;
